<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 20:06:36
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-10-21 15:18:47
-->
<template>
	<Search @onSearch="onSubmit" @onReset="onClear">
		<div class="yx-form-wrap">
			<el-form :inline="true" :model="formData" label-width="96px">
				<el-form-item label="店铺名称">
					<el-input v-model="formData['outerShopName']" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="店铺ID">
					<el-input v-model="formData['shopId']" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="商品名称">
					<el-input v-model="formData['outerProductName']" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="商品ID">
					<el-input v-model="formData['productId']" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="团长名称">
					<el-input v-model="formData['institutionName']" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="团长ID">
					<el-input v-model="formData['authorityId']" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="商品类目" key="1" v-if="$isDy(platformId)">
					<yx-category-select
						v-model="formData['cateId']"
						:multiple="true"
						:clearable="true"
						:platformId="platformId"
						isGoodsCat
					></yx-category-select>
				</el-form-item>
				<el-form-item label="商品类目" key="2" v-if="$isKs(platformId)">
					<yx-category-select
						v-model="formData['cateId']"
						:multiple="true"
						:clearable="true"
						:platformId="platformId"
						isGoodsCat
					></yx-category-select>
				</el-form-item>
				<el-form-item label="服务费率≥">
					<el-input v-model="formData['serviceFeeRate']" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="达人佣金≥">
					<el-input v-model="formData['talentCommission']" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="是否人工审核">
					<el-select v-model="formData['auditStatus']" clearable placeholder="请选择">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in examineList" :key="index"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
	</Search>
</template>

<script>
import throttle from 'lodash/throttle';
import YxCategorySelect from '@/components/yxCategorySelect';
export default {
	name: 'search',
	components: {
		YxCategorySelect,
	},
	props: {
		platformId: {
			type: [String, Number],
			default: '',
		},
	},
	data() {
		return {
			formData: {},
			examineList: [
				{ label: '是', value: '1' },
				{ label: '否', value: '0' },
			],
		};
	},
	methods: {
		onClear() {
			this.formData = {};
			this.onSubmit();
		},
		onSubmit: throttle(function () {
			this.$emit('onSubmit', { ...this.formData });
		}, 1000),
	},
};
</script>
